import { StateScheme } from 'app/providers/StoreProvider/config/StateScheme'

export const getPaymentCurrentBalance = (state: StateScheme) => {
    return state.payment.currentBalance
}
